import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import userDetail from "Stores/userDetail";
import BreadCrumbComponent from "Components/common/breadcrumb";
import UserFilterDropdown from "./LiveFeed/Components/UserFilterDropdown";
import DashboardState from "./mainState";
import DashboardV2 from "./DashboardV2/DashboardV2";
import DateFilter from "./DashboardV2/DateFilter/DateFilter";
import LiveFeed from "./LiveFeed/main";
import widgetDataStore from "./DashboardV2/store/widgetDataStore";
import dashboardV2Store from "./DashboardV2/store/dashboardV2Store";
import { initialWelcomePopupState } from "Components/common/InitialWelcomePopup";

const Dashboard = observer(props => {
  const breadcrumbArr = [{ name: "Overview", link: "/dashboard" }];
  const {
    team = false,
    memberId = "",
    hasTeamMember = false,
    isTeamOwner = false
  } = userDetail?.userInfo || {};

  const { noOfSequencesUsed = 0, isOnBoardingCompleted = false } =
    userDetail.userFeatureFlag || {};

  const getSelectedUsers = obj => {
    const memberIds =
      obj && typeof obj === "object" && Object.keys(obj)?.length > 0
        ? obj
        : obj?.length && obj?.toLowerCase() === "you"
          ? new Array(memberId)
          : "";
    return memberIds;
  };

  const getSelectedUser = value => {
    const selectedIds = getSelectedUsers(value);
    DashboardState.setMemberId(selectedIds);
  };

  useEffect(() => {
    const isWelcomePopupShown = localStorage.getItem("isWelcomePopupShown");
    if (
      !isOnBoardingCompleted &&
      !isWelcomePopupShown &&
      !noOfSequencesUsed > 0
    ) {
      localStorage.setItem("isWelcomePopupShown", true);
      initialWelcomePopupState.setShowPopup(true);
    }
    return () => {
      DashboardState.setMemberId("");
    };
  }, []);

  return (
    <section className="dashboardPage">
      <div className="headerSection">
        <BreadCrumbComponent breadCrumbValue={breadcrumbArr} />
        {dashboardV2Store.activeDashboard && (
          <button
            type="button"
            className="dashboardV2NewWidgetBtn"
            onClick={() => dashboardV2Store.setShowWidgetCatalog(true)}
          >
            + New widget
          </button>
        )}
      </div>
      <div className="dashboardWrapper">
        <div className="filterSectionWrap">
          <div className="topFilter">
            <DateFilter
              activeFilter={widgetDataStore.activeDateFilter}
              onSelect={preset => widgetDataStore.setDateFilter(preset)}
            />
            {((team && hasTeamMember?.length > 1) || isTeamOwner) && (
              <UserFilterDropdown
                team={team}
                selectedUserCbk={getSelectedUser}
              />
            )}
          </div>
        </div>
        <div className="dashboardContainer">
          <div className="leftSection">
            <DashboardV2 />
          </div>
          <div className="rightSection liveFeedSettingBarWeb">
            <LiveFeed />
          </div>
        </div>
      </div>
    </section>
  );
});

export default withRouter(Dashboard);
export { Dashboard };
